export default "__VITE_ASSET__5675f58b__"